// Deactivate Code
export const DEACTIVATE_CODE_REQUEST = 'DEACTIVATE_CODE_REQUEST';
export const DEACTIVATE_CODE_DONE = 'DEACTIVATE_CODE_DONE';
export const DEACTIVATE_CODE_FAILED = 'DEACTIVATE_CODE_FAILED';
